import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { QueryTable } from "@/components/query-table/QueryTable";
import Spinner from "@/components/Spinner";
import { Module } from "@/constants";
import { ContractorVisitsService } from "@/modules/projects/services/contractorVisits";
import {
  basicSummaryContractorVisit,
  summaryContractorVisit,
} from "@/schemas/contractorVisit";
import { SummaryContractorVisit } from "@/types/contractorVisit";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";

interface ContractorVisitsSummaryProps {
  projectId: string;
  period: string;
  storeId: string;
  hasFullAccess?: boolean;
}

export const ContractorVisitsSummary = ({
  projectId,
  period,
  storeId,
  hasFullAccess = true,
}: ContractorVisitsSummaryProps) => {
  const name = "contractorVisitSummary";

  const schema = hasFullAccess
    ? summaryContractorVisit
    : basicSummaryContractorVisit;

  const fetchSummary = useCallback(async () => {
    return ContractorVisitsService.getSummary(projectId, storeId, period);
  }, [period, projectId, storeId]);

  const query = useQuery({
    queryKey: [Module.ContractorVisits, "summary", projectId, storeId, period],
    queryFn: fetchSummary,
  });

  const options = useCreateDataTableOptions<SummaryContractorVisit>(name);

  if (query.isFetching) {
    return <Spinner />;
  }

  return (
    <QueryTable
      name={name}
      schema={schema}
      query={query}
      options={options}
      translationKey="projectContractorVisits.summary"
    >
      <QueryTable.Menubar>
        <QueryTable.Menubar.Columns />
        <QueryTable.Menubar.Settings />
      </QueryTable.Menubar>
      <DataTableQueryContextProvider value={{ query }}>
        <QueryTable.Content />
      </DataTableQueryContextProvider>
    </QueryTable>
  );
};
